const GraduationCapIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" />
    </svg>
);
// const MailIcon = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
//     </svg>
// );
// const PhoneIcon = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//         <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.56 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
//     </svg>
// );
const AwardIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="6" /><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
    </svg>
);
const UsersIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);

/* ─────────────────────────────────────────────
   Fallback images used when admin has NOT
   uploaded a custom photo yet.
───────────────────────────────────────────── */
const FALLBACK_IMAGES = [
    'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&q=80',
    'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&q=80',
    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&q=80',
];

/* ─────────────────────────────────────────────
   Default profiles – used only when the admin
   has never edited the block (no profiles attr).
   Once the admin saves anything, aboutUs.profiles
   is the single source of truth.
───────────────────────────────────────────── */
const DEFAULT_PROFILES = [
    {
        name: 'Miss Anika Tahsin',
        title: 'Chairperson',
        description:
            'Miss Anika Tahsin is the Chairperson and a Board Member, driving the company\'s strategic vision with a strong focus on innovation and technology. She leads the advancement of the IT function while overseeing overall management, ensuring operational excellence and sustainable growth. Since joining in 2019, she has played a pivotal role in positioning the company to deliver forward-thinking solutions and dependable client services in an evolving digital landscape.',
        education: [
            'Miss Tahsin holds a First Class degree in Electrical and Electronic Engineering and a Master of Science in Communications and Signal Processing from the University of Manchester.',
        ],
        image: '',
    },
    {
        name: 'Nahid Ahmed',
        title: 'Managing Director',
        description:
            'Nahid Ahmed is the Managing Director of GMF Securities Ltd., guiding the firm with a strong focus on client service, governance, and sustainable growth in the capital market. Further details and photographs are maintained on the corporate website.',
        education: [],
        image: '',
    },
    {
        name: 'Mr. Faheem Faisal Ahmed',
        title: 'Director',
        description:
            'Faheem Faisal Ahmed is the Director of GMF Securities Ltd., bringing a strong foundation in finance, entrepreneurship, and strategic growth to the company. Since joining in 2019, Faheem has played a key role in driving business development and modernizing operations, with a focus on expanding market presence and enhancing client experience. He is actively involved in shaping the firm\'s long-term vision, including the development of digital platforms to improve accessibility and efficiency in trading services. With a deep interest in financial markets and investment strategies, Faheem is committed to building a forward-thinking brokerage that delivers value, transparency, and sustainable growth for its clients.',
        education: [
            'He holds a Bachelor of Business degree with a major in Entrepreneurship and Innovation from the University of Newcastle.',
        ],
        image: '',
    },
];

/* ─────────────────────────────────────────────
   Component
───────────────────────────────────────────── */
const AboutUs = ({ attributes }) => {
    const { aboutUs } = attributes;

    // Use admin-saved profiles if available, otherwise fall back to defaults
    const profiles =
        Array.isArray(aboutUs.profiles) && aboutUs.profiles.length > 0
            ? aboutUs.profiles
            : DEFAULT_PROFILES;

    // For each profile, use uploaded image if set, else cycle through fallbacks
    const resolvedProfiles = profiles.map((p, i) => ({
        ...p,
        image: p.image || FALLBACK_IMAGES[i % FALLBACK_IMAGES.length],
    }));

    // CTA text (admin-editable, with sensible defaults)
    const ctaTitle = aboutUs.ctaTitle || 'Leading with Integrity';
    const ctaText = aboutUs.ctaText ||
        'At GMF Securities Ltd., our leadership is committed to maintaining the highest standards of corporate governance and client service.';

    return (
        <div className="gmf-page-wrapper">

            {/* ── Page Hero ── */}
            <section className="gmf-page-hero">
                <div className="gmf-page-hero-inner">
                    {aboutUs.subtitle ? (
                        <p className="gmf-page-eyebrow gmf-accent-color">{aboutUs.subtitle}</p>
                    ) : null}
                    <h1 className="gmf-page-title">{aboutUs.title || 'About Us'}</h1>
                    <div className="gmf-divider gmf-divider--center" />
                    <p className="gmf-page-subtitle">
                        {aboutUs.description ||
                            'Meet the leadership team behind GMF Securities Ltd., dedicated to your financial success and growth.'}
                    </p>
                </div>
            </section>

            {/* ── Team Profiles ── */}
            <section className="gmf-about-profiles">
                {resolvedProfiles.map((profile, index) => (
                    <div
                        key={index}
                        className={`gmf-profile-card gmf-card ${index % 2 !== 0 ? 'gmf-profile-card--reverse' : ''}`}
                    >
                        {/* Photo */}
                        <div className="gmf-profile-img-wrap">
                            <img
                                src={profile.image}
                                alt={profile.name}
                                className="gmf-profile-img"
                                referrerPolicy="no-referrer"
                            />
                            <div className="gmf-profile-img-overlay" />
                            <div className="gmf-profile-img-badge">
                                <span className="gmf-tag">{profile.title}</span>
                            </div>
                        </div>

                        {/* Text content */}
                        <div className="gmf-profile-content">
                            <div className="gmf-profile-name-wrap">
                                <h2 className="gmf-profile-name">{profile.name}</h2>
                                <div className="gmf-profile-title-row">
                                    <span className="gmf-accent-color"><AwardIcon /></span>
                                    <span className="gmf-profile-role gmf-accent-color">
                                        {profile.title}
                                    </span>
                                </div>
                            </div>

                            <p className="gmf-profile-desc gmf-border-left">
                                {profile.description}
                            </p>

                            {/* Education — only shown if entries exist */}
                            {Array.isArray(profile.education) && profile.education.length > 0 && (
                                <div className="gmf-profile-education">
                                    <div className="gmf-profile-edu-heading">
                                        <span className="gmf-accent-color"><GraduationCapIcon /></span>
                                        <span>Educational Background</span>
                                    </div>
                                    <ul className="gmf-profile-edu-list">
                                        {profile.education.filter(Boolean).map((edu, i) => (
                                            <li key={i} className="gmf-profile-edu-item">
                                                <span className="gmf-dot" />
                                                <span>{edu}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            <div className="gmf-profile-actions">
                                {/* <button className="gmf-icon-action-btn" aria-label="Email">
                                    <MailIcon />
                                </button>
                                <button className="gmf-icon-action-btn" aria-label="Phone">
                                    <PhoneIcon />
                                </button> */}
                            </div>
                        </div>
                    </div>
                ))}
            </section>

            {(aboutUs.mission || aboutUs.vision) && (
                <section className="gmf-privacy-sections" style={{ maxWidth: 1000, margin: '0 auto 48px', padding: '0 20px' }}>
                    {aboutUs.mission ? (
                        <div className="gmf-privacy-section-card">
                            <div className="gmf-privacy-section-header">
                                <h2 className="gmf-privacy-section-title">Mission</h2>
                            </div>
                            <div className="gmf-privacy-section-content">
                                <p>{aboutUs.mission}</p>
                            </div>
                        </div>
                    ) : null}
                    {aboutUs.vision ? (
                        <div className="gmf-privacy-section-card">
                            <div className="gmf-privacy-section-header">
                                <h2 className="gmf-privacy-section-title">Vision</h2>
                            </div>
                            <div className="gmf-privacy-section-content">
                                <p>{aboutUs.vision}</p>
                            </div>
                        </div>
                    ) : null}
                </section>
            )}

            {/* ── Stats ── */}
            {Array.isArray(aboutUs.stats) && aboutUs.stats.length > 0 && (
                <section className="gmf-about-stats">
                    <div className="gmf-stats-grid">
                        {aboutUs.stats.map((stat, index) => (
                            <div key={index} className="gmf-stat-item gmf-card">
                                <div className="gmf-stat-value">{stat.value}</div>
                                <div className="gmf-stat-label">{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            {/* ── Footer CTA ── */}
            <section className="gmf-page-cta">
                <div className="gmf-page-cta-inner">
                    <div className="gmf-cta-icon gmf-accent-bg">
                        <UsersIcon />
                    </div>
                    <h2 className="gmf-cta-title">{ctaTitle}</h2>
                    <p className="gmf-cta-text">{ctaText}</p>
                </div>
            </section>
        </div>
    );
};

export default AboutUs;
